import { DisplayAccountViewModel } from './display-account-view-model.type';
import { MonitorKey } from '../../monitor-models/monitor-key.type';

export class RegisterAccountViewModel {
  Password: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Language: string;
  ConfirmPassword: string;
  IsMainDashboardAllowed = true;
  AvailableScreenKeys: MonitorKey[] = [];
  SharedPlaylistsIds: number[] = [];
  SharedMonitorTagsIds: number[] = [];
  Roles: string[] = [];
  AvailableMachines: string[] = [];
  AvailableCategories: number[];
  HasAccessToRemoteControl: boolean;
  HasAccessToDisconnectAgents: boolean;
  TwoFactorEnabled: boolean;
  ShouldConfirmEmail: boolean;
  EmailConfirmed: boolean;

  constructor(user: DisplayAccountViewModel = null) {
    if (user) {
      Object.assign(this, user);
    }
  }
}
